<ion-grid>
    <ion-row>
        <ion-col size="12">
            <canvas baseChart height="300"
                    [data]="doughnutChartData"
                    [labels]="doughnutChartLabels"
                    [colors]="doughnutChartColors"
                    [options]="doughnutChartOptions"
                    [plugins]="doughnutChartPlugins"
                    [chartType]="doughnutChartType">
            </canvas>
        </ion-col>
    </ion-row>
</ion-grid>
